exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".emojione {\n  /* Emoji Sizing */\n  font-size: inherit;\n  height: 3ex;\n  width: 3.1ex;\n  min-height: 20px;\n  min-width: 20px;\n\n  /* Inline alignment adjust the margins  */\n  display: inline-block;\n  margin: -.2ex .15em .2ex;\n  line-height: normal;\n  vertical-align: middle;\n}\n\nimg.emojione {\n  /* prevent img stretch */\n  width: auto;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1!./~/postcss-loader!./~/emojione/assets/css/emojione.css
// module id = 2004
// module chunks = 0